export enum LeavingReasonEnum {
    SALARY = 'SALARY',
    WORK_ENVIRONMENT = 'WORK_ENVIRONMENT',
    CAREER_GROWTH = 'CAREER_GROWTH',
    BETTER_OPPORTUNITY = 'BETTER_OPPORTUNITY',
    BETTER_COMPENSATION = 'BETTER_COMPENSATION',
    BAD_MANAGEMENT = 'BAD_MANAGEMENT',
    OTHER  = 'OTHER '        
}